import { ensureExists } from "@/lib/ensureExists";
import { createFileRoute } from "@tanstack/react-router";
import Comparison from "@/pages/Comparison";

export const Route = createFileRoute("/compare/$slug")({
  beforeLoad: ({ params }) => ensureExists("comparison_tables", params.slug),
  component: Comparison,
});
